import React, { useMemo, useState, useEffect } from "react";
import { connect } from 'react-redux';
import {  Link, withRouter, useHistory } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import {Modal,ModalBody,ModalHeader,Button,Card,CardBody,ButtonToolbar,Row,Col,
} from "reactstrap";
import ReactTableBase from "@/shared/components/table/ReactTableBase";
import { useDispatch, flashSuccess, flashError, sendFlashMessage } from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import AddEventForm from './AddEventForm';
// import AddIconForm from './AddIconForm'
import { COLUMNS } from "./columns"
import axios from 'axios'
import RemoveHierarchyModal from "./RemoveHierarchyModal";
import RemoveSelectedHierarchyModal from "./RemoveSelectedHierarchyModal";
import DeletedResultHierarchyModal from "./DeletedResultHierarchyModal";
import CheckboxField from "@/shared/components/form/CheckboxField";

const EventsDataModal = ({isOpen,toggle,data,theme,rtl,
}) => {
  const tableConfig = {
    isResizable: true,
    isSortable:false
  }
  
  const [step, setStep] = useState(0);  
  const [loading, setLoading] = useState(false);  
  const [localMessage, setLocalMessage] = useState(null);
  var [data, setData] = useState(data)
  var [programEvents, setProgramEvents] = useState([])
  const flashDispatcher = useDispatch()
const [checkedState, setCheckedState] = useState([]);
const [selectedEventId, setSelectedEventId] = useState(null);
const [isDeleteHierarchy, setDeleteHierarchy] = useState(false);
const [isDeleteHierarchyList, setDeleteHierarchyList] = useState(false);
const [deleteHierarchyListData, setDeleteHierarchyListData] = useState([]);
const [isDeleteHierarchyResult, setDeleteHierarchyResult] = useState(false);
const [deletehierarchyListDataResult, setdeleteHierarchyListDataResult] =
  useState([]);
let history = useHistory();

const toggleDeleteHierarchy = (eventId) => {
  setSelectedEventId(eventId);
  setDeleteHierarchy((prevState) => !prevState);
};

const toggleDeleteHierarchyList = () => {
  setDeleteHierarchyList((prevState) => !prevState);
};

const toggleDeleteHierarchyResult = () => {
  setDeleteHierarchyResult((prevState) => !prevState);
};

const columnsDeleteHierarchyList = [
  {
    title: "Delete?",
    key: "action",
    render: (_, record, index) => (
      <>
        <div className="checkbox-custom2">
          <CheckboxField
            name={`action-checkbox-${record.event_id}`}
            checked={checkedState[index].checked}
            disabled={
              checkedState[index].value === Number(selectedEventId)
                ? true
                : false
            }
            onChange={(e) => {
              const tmpCheckedState = [...checkedState];
              tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
              setCheckedState(tmpCheckedState);
            }}
          />
        </div>
      </>
    ),
  },
  {
    title: "Event ID",
    dataIndex: "event_id",
    key: "event_id",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Event Name",
    dataIndex: "event_name",
    key: "event_name",
  },
  {
    title: "Program Name",
    dataIndex: "program_name",
    key: "event_name",
  },
  {
    title: "Event Type",
    dataIndex: "event_type",
    key: "event_type",
  },
];

const columnsHierarchyResult = [
  {
    title: "Program ID",
    dataIndex: "id",
    key: "id",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Program Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Result",
    dataIndex: "result",
    key: "result",
  },
];

  const fetchProgramEvents = async(organizationId, programId) => {
    setLoading(true)
    try {
        const response = await axios.get(`/organization/${organizationId}/program/${programId}/event?disabled=true`);
        setProgramEvents(response.data);
        setLoading(false)
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};

const onClickDeleteEvent = (e, event_id) => {

    axios.delete(
        `/organization/${data.organization_id}/program/${data.id}/event/${event_id}`
    )
    .then((res) => {
      if (res.status == 200) {
        setLocalMessage('Event was deleted!');
        setProgramEvents((prevEvents) =>
          prevEvents.filter((event) => event.id !== event_id)
        );
        setLoading(false);
        toggleDeleteHierarchy();
      }
    })
    .catch((err) => {
      console.log(err.response.data);
      flashDispatcher(sendFlashMessage(<ApiErrorMessage errors={err.response.data} />, 'alert-danger'));
      setLoading(false);
    });
  };

   const onDeleteHierarchy = () => {
     axios
       .get(
         `/organization/${data.organization_id}/program/${data.id}/event/${selectedEventId}/delete-hierarchy-list`
       )
       .then((res) => {
         if (res.status == 200) {
           setDeleteHierarchyListData(res.data);
           const tmpCheckedState = [];
           res.data.map((item) => {
             tmpCheckedState.push({ checked: true, value: item.event_id });
           });
           setCheckedState(tmpCheckedState);
           toggleDeleteHierarchyList();
           toggleDeleteHierarchy(selectedEventId);
         }
       })
       .catch((err) => {
         flashError(flashDispatcher, err.response.data);
         setLoading(false);
         toggleDeleteHierarchyList();
       });
   };

   const onDeleteHierarchyList = () => {
     const eventData = {};
     const eventIds = checkedState
       .filter((item) => item.checked)
       .map((item) => item.value);
     eventData.event_ids = eventIds;

     axios
       .delete(
         `/organization/${data.organization_id}/program/${data.id}/event/${selectedEventId}/delete-event-hierarchy`,
         {
           data: eventData,
         }
       )
       .then((res) => {
         if (res.status === 200) {
           const list = res.data.deleted_data;
           setdeleteHierarchyListDataResult(list);
           flashSuccess(flashDispatcher, "Event(s) deleted successfully!");
           setProgramEvents((prevEvents) =>
             prevEvents.filter((event) => event.id !== selectedEventId)
           );
           toggleDeleteHierarchyResult();
           toggleDeleteHierarchyList();
         }
       })
       .catch((err) => {
         flashError(
           flashDispatcher,
           err.response?.data || "Failed to fetch delete list"
         );
         setLoading(false);
         toggleDeleteHierarchyResult();
       });
   };

  setTimeout(() => setLocalMessage(null), 3000);
    const RenderActions = ({ row }) => {
        return (
          <>
            <Link
              className="link a"
              to={`/program/${data.id}/event/${row.original.id}/edit`}
            >
              Edit
            </Link>
            {" | "}
            <span
              //  onClick={(e) => {
              //     if (window.confirm("Are you sure to delete this Event?")) {
              //     onClickDeleteEvent(e, row.original.id);
              //     }
              // }}
              onClick={() => toggleDeleteHierarchy(row.original.id)}
              className="link a"
            >
              Delete
            </span>
          </>
        );
    }
    
  useEffect(() => {
    fetchProgramEvents(data.organization_id, data.id)
  },[data])

    const event_columns = [
    ...COLUMNS,
    {
        Header: "",
        accessor: "action",
        Cell: ({ row }) => <RenderActions row={row} />,
        width: 200,
    },
    ];

  const columns = useMemo(() => event_columns, []);

  const handleStep = (step) =>{
    setStep(step);
  }
  
  const RenderEventsData = (props) =>{

    if( loading ) return 'Loading...'
        
    return (
      <>
        <Row className="w100">
            <Col md="6" lg="6" xl="6">
              <div className="react-table__wrapper">
                <div className="card__title">
                  <h5 className="bold-text">Events</h5>
                  <h5 className="subhead">Create/View award events</h5>
                </div>
              </div>
            </Col>
            <Col md="6" lg="6" xl="6" className="text-right">
              <ButtonToolbar className="modal__footer flex justify-content-right w100">
                  <Button
                    outline
                    color="primary"
                    className="mr-3"
                    onClick={toggle}
                  >
                  Close
                  </Button>{" "}
                  <Button
                    type="submit"
                    onClick = {() => props.onStep(1)}
                    className="btn btn-primary"
                    color="#ffffff"
                  >
                    Add Event
                  </Button>
              </ButtonToolbar>
            </Col>
          </Row>
          {localMessage && (
            <div className="alert alert-success" role="alert">
                {localMessage}
            </div>
        )}
          <ReactTableBase
              columns={columns}
              data={programEvents}
              tableConfig={tableConfig}
          />
      </>
    )
  }
  
  return (
    <>
      <Modal
        className={`modal-program modal-lg ${theme.className} ${rtl.direction}-support`}
        isOpen={isOpen}
        toggle={toggle}
      >
        <ModalBody className="modal-lg">
          <Col md={12} lg={12}>
            {step === 0 && (
              <RenderEventsData programId={data.id} onStep={handleStep} />
            )}
            {step === 1 && <AddEventForm onStep={handleStep} program={data} />}
            {/* { step === 2 && <AddIconForm onStep = { handleStep} />} */}
          </Col>
        </ModalBody>
      </Modal>
      <RemoveHierarchyModal
        isDeleteHierarchy={isDeleteHierarchy}
        toggleDeleteHierarchy={toggleDeleteHierarchy}
        onDeleteHierarchy={onDeleteHierarchy}
        onClickDeleteEvent={onClickDeleteEvent}
        eventId={selectedEventId}
      />

      <RemoveSelectedHierarchyModal
        isDeleteHierarchyList={isDeleteHierarchyList}
        toggleDeleteHierarchyList={toggleDeleteHierarchyList}
        onDeleteHierarchyList={onDeleteHierarchyList}
        columnsDeleteHierarchyList={columnsDeleteHierarchyList}
        deleteHierarchyListData={deleteHierarchyListData}
      />

      <DeletedResultHierarchyModal
        isDeleteHierarchyResult={isDeleteHierarchyResult}
        toggleDeleteHierarchyResult={toggleDeleteHierarchyResult}
        columnsHierarchyResult={columnsHierarchyResult}
        deletehierarchyListDataResult={deletehierarchyListDataResult}
        programId={data.id}
        history={history}
      />
    </>
  );
};

EventsDataModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  data: Object.isRequired
};

export default withRouter(connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  data: state.program
}))(EventsDataModal));